import React from 'react';

import ArrowIcon from 'mdi-react/ChevronLeftIcon';
import CogWheel from 'mdi-react/SettingsIcon';

import Button from '@prisjakt/ui-button';
import Dropdown from '@prisjakt/ui-dropdown-new';

import * as S from './styles';

import { SidebarHeaderOption } from '../sharedTypes';

type SidebarHeaderProps = {
  goBack?: () => void;
  title: string;
  options?: SidebarHeaderOption[];
  settingsIcon?: React.ReactNode;
};

const SidebarHeader = ({
  goBack = undefined,
  title,
  options,
  settingsIcon,
}: SidebarHeaderProps) => {
  return (
    <S.SidebarHeader>
      {goBack && (
        <S.GoBackButton>
          <Button variant="icon" onClick={goBack} icon={<ArrowIcon />} />
        </S.GoBackButton>
      )}
      <S.Title>{title}</S.Title>

      <S.SettingsButton>
        {options && options.length > 1 && (
          <Dropdown
            variant="secondary"
            grow="left"
            toggleElement={
              <S.SettingsButton>
                <Button
                  variant="icon"
                  icon={
                    <S.SettingsIcon component={settingsIcon || <CogWheel />} />
                  }
                />
              </S.SettingsButton>
            }
            showArrow={false}
          >
            <>
              {options.map(
                option =>
                  option &&
                  option.title &&
                  option.handler && (
                    <S.OptionButton type="button" onClick={option.handler}>
                      {option.title}
                    </S.OptionButton>
                  )
              )}
            </>
          </Dropdown>
        )}

        {options &&
          options.length === 1 &&
          options[0] &&
          options[0].handler && (
            <Button
              variant="icon"
              icon={<S.SettingsIcon component={settingsIcon || <CogWheel />} />}
              onClick={options[0].handler}
            />
          )}
      </S.SettingsButton>
    </S.SidebarHeader>
  );
};

export default SidebarHeader;
